import { DataSourceMode } from "@mcleod/components";
import { AutogenLayoutTrailerList } from "./autogen/AutogenLayoutTrailerList";

export class TrailerList extends AutogenLayoutTrailerList {
    async tableTrailerAfterCrudClose(event) {
        if (event.dataSourceMode === DataSourceMode.ADD || event.dataSourceMode === DataSourceMode.UPDATE) {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
        }
    }

    override onLoad() {
        this.mainDataSource.search({is_active: "A"});
    }
}
